import React from "react";
import Axios from 'axios'
import moment from 'moment';
import LoadCircle from "../_Components/LoadCircle";
import DetalhamentoPedido from "../_Components/DetalhamentoPedido";
import API from '../Utils/api';
import CambistaTemplate from "./CambistaTemplate";

export class RelatoriosCambista extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      historicos: [],
      pedidos: [],
      relatorio: null,
      historicoSelecionado: null,
      isLoad: false,
      progress: 0,
      intervalo: null,
      pedidoSelecionado: null,
      gerentes: [],
      clientes: [],
      cambistaSelecionado: JSON.parse(localStorage.getItem("user")),
      clienteSelecionado: null,
      gerenteSelecionado: null,
      checkOrderType: false,
      isApp: false
    };
    this.getHistoricos();

    this.getClientePorCambista();
  }


  setCliente(e) {
    this.state.clienteSelecionado = JSON.parse(e.target.value);
    this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
    // this.buscarPedidos()
  }

  async getClientePorCambista() {
    if (this.state.cambistaSelecionado != null) {
      try {
        const response = await API.post("/api/usuarios/listar-por-tutor", {
          tutorId: this.state.cambistaSelecionado._id
        });
        this.setState({ clientes: response.data.sort(this.compararNome) });
        // this.buscarPedidos()
      } catch (err) {
        console.log(err);
      }
    }
  };


  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }


  deselecionarPedido(event) {
    this.setState({ pedidoSelecionado: null, clienteSelecionado: null })
    this.forceUpdate()
  }

  selecionarPedido(event) {
    const pedido = JSON.parse(event.target.accessKey)
    this.setState({ pedidoSelecionado: event.target.accessKey, clienteSelecionado: JSON.stringify(pedido.clienteId) })
    this.forceUpdate()
  }

  async getPedidoPorTransacao(e) {
    try {
      const response = await API.post("/api/pedidos/por-transacao", {
        transacaoId: e._id
      });
      return response.data
    } catch (err) {
      console.log(err);
    }
  };

  async getHistoricos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      })
      const response = await axiosInstance.get("historicos/")

      this.setState({ historicos: response.data })

    } catch (err) {
      console.log(err)
    }
  }

  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  selecionaIntervalo(e) {
    var historico = JSON.parse(e.target.value).historico
    this.state.historicoSelecionado = historico;
    this.setState({ historicoSelecionado: historico })
    // this.buscarPedidos()
  }

  async buscarPedidos() {
    if (this.state.historicoSelecionado != null) {
      this.setState({ isLoad: true })
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        })
        const response = await axiosInstance.post("pedidos/master-relatorio-intervalo-cambista",
          {
            dataInicial: this.state.historicoSelecionado.dataInicial,
            dataFinal: this.state.historicoSelecionado.dataFinal,
            cliente: this.state.clienteSelecionado,
            cambista: this.state.cambistaSelecionado,
            isApp: this.state.isApp
          })
        this.setState({ pedidos: response.data })

        if (response.data.length > 0) {

          this.gerarRelatorioPorData()
        }
        else {
          this.setState({ isLoad: false })
          var relatorio = {
            historico: this.state.historicoSelecionado,
            pedidos: this.state.pedidos,
            cartelasValidadas: 0,
            valorTotal: 0,
            totalEmComissoes: 0
          }
          this.setState({ isLoad: false, relatorio: relatorio })
        }

      } catch (err) {
        console.log(err)
      }
    }

  }

  gerarRelatorioPorData() {
    var { pedidos, historicoSelecionado } = this.state;
    if (historicoSelecionado == null) {
      alert("Selecione um intervalo")
      return;
    }
    else if (pedidos.length == 0) {
      alert("Não possui nenhum pedido!")
      return;
    }
    else {
      var relatorio = {
        historico: this.state.historicoSelecionado,
        pedidos: this.state.pedidos,
        cartelasValidadas: 0,
        valorTotal: 0,
        totalEmComissoes: 0
      }
      var pedidos = []
      if (this.state.checkOrderType == "Avulsos") {
        this.state.pedidos.map(pedido => {
          if (pedido.transacaoId != undefined && pedido.transacaoId.documento == "Documento Avulso") {
            relatorio.valorTotal += pedido.transacaoId.valor;
            relatorio.totalEmComissoes += pedido.transacaoId.taxaComissao;
            pedidos.push(pedido);
          }

          if (pedido.validado && pedido.transacaoId.documento == "Documento Avulso") {
            pedido.cartelas.map(cartela => {
              relatorio.cartelasValidadas += 1;
            })
          }
        })
      }
      else if (this.state.checkOrderType == "Online") {
        this.state.pedidos.map(pedido => {
          if (pedido.transacaoId != undefined && pedido.transacaoId.documento !== "Documento Avulso") {
            relatorio.valorTotal += pedido.transacaoId.valor;
            relatorio.totalEmComissoes += pedido.transacaoId.taxaComissao;
            pedidos.push(pedido);
          }

          if (pedido.validado && pedido.transacaoId.documento !== "Documento Avulso") {
            pedido.cartelas.map(cartela => {
              relatorio.cartelasValidadas += 1;
            })
          }
        })
      }
      else {
        this.state.pedidos.map(pedido => {
          if (pedido.transacaoId != undefined) {
            relatorio.valorTotal += pedido.transacaoId.valor;
            relatorio.totalEmComissoes += pedido.transacaoId.taxaComissao;
            pedidos.push(pedido);
          }

          if (pedido.validado)
            pedido.cartelas.map(cartela => {
              relatorio.cartelasValidadas += 1;
            })
        })
      }
      this.state.pedidos = pedidos;
      relatorio.pedidos = pedidos;
      this.setState({ relatorio: relatorio, isLoad: false, pedidos: pedidos })
    }
  }

  onLoading() {
    if (this.state.pedidos.length > 0) {
      this.setState({ isLoad: false });
      clearInterval(this.state.intervalo);
    }
    this.setState({ progress: this.state.progress + 1 });
  }
  onLoad() {
    this.setState({ pedidos: [], isLoad: true, intervalo: setInterval(this.onLoading.bind(this), 300) })
  }

  selectOrderType(e) {
    this.state.checkOrderType = e.target.value
    this.state.isApp = e.target.value == 'App'? true : false ;
    this.setState({ checkOrderType: e.target.value, isApp: e.target.value == 'App'? true : false })
    this.buscarPedidos();
  }

  handlerRelatorioByApp (e){
    this.state.isApp = e.target.checked;
    this.setState({isApp : e.target.checked, isLoad: true})
    this.buscarPedidos();
  }

  render() {
    return (
      <CambistaTemplate label="Relatorios">
        {this.state.isLoad ? <LoadCircle></LoadCircle> : ""}
        <div className="container">
          <div className="row" style={{ alignItems: 'center'}}>
            <select onChange={this.selecionaIntervalo.bind(this)} class="ml-3 custom-select">
              <option value={JSON.stringify(null)} selected >Selecione um intervalo</option>
              {this.state.historicos.map(historico => {
                return <option value={JSON.stringify({ historico })}>{this.formatDate(historico.dataInicial)} ➨ {this.formatDate(historico.dataFinal)} </option>
              })}

            </select>
            <select onChange={this.setCliente.bind(this)} style={{ maxWidth: '10em' }} class="ml-1 custom-select">
              <option value={JSON.stringify(null)} selected>Todos os clientes</option>
              {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                return <option value={JSON.stringify(cliente)}>{cliente.nome}</option>
              }) : ""}
            </select>

            <select onChange={this.selectOrderType.bind(this)} class="ml-1 custom-select">
              <option value="Todos" selected>Todos</option>
              <option value="App">Pedidos no App</option>
              <option value="Avulsos">Pedidos avulsos</option>
              <option value="Online">Pedidos online</option>

            </select>

            <button className="ml-1 btn-fill btn btn-primary" disabled={this.state.isLoad == true ? true : false}  onClick={this.buscarPedidos.bind(this)}>Gerar relatório</button>
              {/* <input type="checkbox" style={{marginLeft: 6, width: 22, height: 22, fontSize: 12}} onChange={this.handlerRelatorioByApp.bind(this)}></input>
              <label style={{marginLeft: 6, fontWeight: 'bold', fontSize: 12, marginTop: 8}}>apenas App</label> */}
          </div>

        </div>
        <div className="mt-3 ml-3 pl-3 pr-3 rounded border bg-white" style={{ maxWidth: '90%' }}>
          <table className="table">
            <thead  >
              <tr>
                <th scope="col">Intervalo</th>
                {/* <th scope="col">Cartelas geradas</th> */}
                <th scope="col">Total de pedidos</th>
                <th scope="col">Cartelas vendidas</th>
                <th scope="col">Valor arrecadado</th>
                {/* <th scope="col">Valor em comissões</th> */}
              </tr>
            </thead>
            <tbody >

              {this.state.relatorio ?

                <tr >
                  <th scope="row">{this.formatDate(this.state.relatorio.historico.dataInicial)} ➨ {this.formatDate(this.state.relatorio.historico.dataFinal)} </th>
                  {/* <td>{this.state.relatorio.historico.qtdCartelasLote}</td> */}
                  <td>{this.state.relatorio.pedidos.length}</td>
                  <td>{this.state.relatorio.cartelasValidadas}</td>
                  <td>R$ : {this.state.relatorio.valorTotal}</td>
                  {/* <td>R$ : {this.state.relatorio.totalEmComissoes}</td> */}

                </tr>


                : ""}


            </tbody>
          </table>

        </div>
        <div onClick={this.deselecionarPedido.bind(this)} class="modal fade" id="exampleModalCenter" tabIndex="-1"
          role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '95vw', marginTop: '-8em' }}
            role="document">
            <div class="modal-content ">
              <div class="modal-header">
                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento
                  pedido</h4>
                <button onClick={this.deselecionarPedido.bind(this)} type="button" class="close"
                  data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {this.state.pedidoSelecionado ? <DetalhamentoPedido user={this.state.clienteSelecionado}
                  pedido={this.state.pedidoSelecionado} /> : ""}
              </div>
              <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>

              </div>
            </div>
          </div>
        </div>

        <div className={this.state.pedidos.length > 0 ? "container-fluid mt-3" : "collapse"}>
          <div className="row">
            <div className="col-md-12">
              <div className="card strpied-tabled-with-hover">
                <div className="card-header ">
                  <h4 className="card-title">
                    Pedidos do sorteio
                  </h4>
                </div>
                <div className="card-body table-full-width table-responsive">
                  <table className="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Codigo</th>
                        <th>Cliente</th>
                        <th>Vendedor</th>
                        <th>Gerente</th>
                        <th>Qtd de cartelas</th>
                        <th>Valor total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.pedidos != null
                        ? Object.entries(this.state.pedidos).map(
                          (item, index) => {
                            return (
                              <tr
                                style={{ cursor: 'pointer' }}
                                accessKey={JSON.stringify(item[1])}
                                data-toggle="modal"
                                data-target="#exampleModalCenter"
                                onClick={this.selecionarPedido.bind(this)}
                              >
                                <td accessKey={JSON.stringify(item[1])}>{this.formatDate(item[1].data)}</td>
                                <td accessKey={JSON.stringify(item[1])}>{item[1].codigo}</td>
                                <td accessKey={JSON.stringify(item[1])}>{item[1].clienteId ? item[1].clienteId.nome : "Desconhecido"}</td>
                                <td accessKey={JSON.stringify(item[1])}>{item[1].cambistaId ? item[1].cambistaId.nome : "Desconhecido"}</td>
                                <td accessKey={JSON.stringify(item[1])}>{item[1].gerenteId ? item[1].gerenteId.nome : "Desconhecido"}</td>
                                <td accessKey={JSON.stringify(item[1])}
                                  className="pl-5">{item[1].cartelas ? item[1].cartelas.length : "0"}</td>
                                <td accessKey={JSON.stringify(item[1])}
                                  className="pl-5">{item[1].cartelas[0] ? (item[1].cartelas.length * item[1].cartelas[0].valor).toFixed(2) : "0"}</td>
                              </tr>
                            );
                          }
                        )
                        : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


      </CambistaTemplate>
    );
  }
}

export default RelatoriosCambista;
